export interface OfferFormData {
  offerName: string;
  offerType: string;
  discountValue: string;
  discountId?: string;
}

export interface OfferFormErrors {
  offerName?: string;
  selectedPlans?: string;
  offerType?: string;
  discountValue?: string;
  startDate?: string;
  endDate?: string;
}

export const INITIAL_FORM_DATA: OfferFormData = {
  offerName: '',
  offerType: 'Procentowy',
  discountValue: '',
  discountId: '',
};
